import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed7bbc5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-backdrop",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Select an item in the ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" category ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]

import { Dialog as CategoryDialog, DialogPanel, DialogTitle, DialogDescription } from "@headlessui/vue"
  import { computed, PropType } from "vue"
  import categories from "@/types/Categories"
  import RoomItemProps from "@/types/RoomItemProps"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryDialog',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    currentCategory: {
      type: Object as PropType<typeof categories[0]>,
      default: undefined,
      required: false,
    },
  },
  emits: ["update:isOpen", "itemSelected"],
  setup(__props, { emit }: { emit: ({
    (e: 'update:isOpen', isOpen: boolean): void
    (e: 'itemSelected', item: Record<any, any>): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props

  

  const shouldShow = computed(() => props.isOpen && !!props.currentCategory)

  

  const close = () => {
    emit("update:isOpen", false)
  }

  const items = computed<RoomItemProps[] | undefined>(() => {
    return props.currentCategory?.items
  })

  const selectItem = (item: Record<any, any>) => {
    emit("itemSelected", item)
    close()
  }

  const getKey = (itemName: string, index: number) => `${itemName} ${index}`

  const getImage = (itemName: string) => {
    return "https://storage.googleapis.com/oliver-render-public/assets/" + itemName
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CategoryDialog), {
    open: _unref(shouldShow),
    onClose: close,
    as: "template",
    class: "dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_unref(DialogPanel), { class: "dialog-panel" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogTitle), null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("em", null, _toDisplayString(__props.currentCategory.name), 1),
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogDescription), { class: "dialog-content" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: getKey(item.name, index),
                    class: "category-item",
                    type: "button",
                    onClick: ($event: any) => (selectItem(item))
                  }, [
                    _createElementVNode("img", {
                      src: getImage(item.image),
                      alt: item.name
                    }, null, 8, _hoisted_5)
                  ], 8, _hoisted_4))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})